import { USER_PERMISSION } from './permission';
import MenuItem from 'types/menu-item';

export const ACCESS_TOKEN = 'accessToken';
export const REFRESH_TOKEN_KEY = 'refresh_token';
export const SELECT_THEME = 'selectedTheme';
export const PERMISSION = 'permission';

export const HTTPS_CODE = {
  success: 200, // Thành công
  unauthorized: 401, // bay ra màn hình 403 k có quyền
  forbidden: 403, // đều bay ra màn hình login
  lockedAccount: 411, // đều bay ra màn hình login
  expiredToken: 413, // Token hết hạn, refreshToken
  notFound: 404, // Không tìm thấy (Not Found)
  serverError: 500, // Lỗi máy chủ (Internal Server Error)
} as const;

export const HTTP_ERROR = [
  HTTPS_CODE.notFound,
  HTTPS_CODE.forbidden,
  HTTPS_CODE.serverError,
];

export const SORT_FILTER = {
  newer: 'asc',
  older: 'desc',
} as const;

export const SORT_FILTER_PAKAGE = {
  ASC: 'ASC',
  DESC: 'DESC',
};

export const ACTION_TYPE = {
  lock: 'lock',
  unlock: 'unlock',
  delete: 'delete',
} as const;

export const PATTERN = {
  password:
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,16}$/,
  noSpecialKey: /^[^~!@#$%^&*()_+={}\[\]|\\:";'<>,.?\/]+$/,
  phone: /^\+?\d+$/,
  number: /^\d+$/,
  floatNumber: /^\d+(\.\d+)?$/,
} as const;

export const ICONS = {
  dashBoard: require('assets/icons/smart-home.svg').ReactComponent,
  admin: require('assets/icons/user.svg').ReactComponent,
  category: require('assets/icons/folders.svg').ReactComponent,
  upload: require('assets/icons/upload.svg').ReactComponent,
  back: require('assets/icons/chevron-left.svg').ReactComponent,
  child: require('assets/icons/circle.svg').ReactComponent,
  pinMenu: require('assets/icons/circle-dot.svg').ReactComponent,
  cloudDown: require('assets/icons/cloud-down-icon.svg').ReactComponent,
  locked: require('assets/icons/lock.svg').ReactComponent,
  unlocked: require('assets/icons/lock-open.svg').ReactComponent,
  edit: require('assets/icons/edit.svg').ReactComponent,
  calendar: require('assets/icons/calendar-minus.svg').ReactComponent,
  plus: require('assets/icons/plus.svg').ReactComponent,
  filter: require('assets/icons/adjustments.svg').ReactComponent,
  search: require('assets/icons/search.svg').ReactComponent,
  song: require('assets/icons/song.svg').ReactComponent,
  short: require('assets/icons/sortVideo.svg').ReactComponent,
  delete: require('assets/icons/trash.svg').ReactComponent,
  close: require('assets/icons/x.svg').ReactComponent,
  bold: require('assets/icons/bold.svg').ReactComponent,
  italic: require('assets/icons/italic.svg').ReactComponent,
  underline: require('assets/icons/underline.svg').ReactComponent,
  unorderedList: require('assets/icons/list.svg').ReactComponent,
  toastSuccess: require('assets/icons/circle-check.svg').ReactComponent,
  toastError: require('assets/icons/alert-circle.svg').ReactComponent,
  eyes: require('assets/icons/eyes.svg').ReactComponent,
  received: require('assets/icons/received.svg').ReactComponent,
  approve: require('assets/icons/approve.svg').ReactComponent,
  reject: require('assets/icons/reject.svg').ReactComponent,
  darkMode: require('assets/icons/dark-mode.svg').ReactComponent,
  global: require('assets/icons/global.svg').ReactComponent,
  draft: require('assets/icons/draft.svg').ReactComponent,
  eyeOff: require('assets/icons/eye-off.svg').ReactComponent,
  alertRefuse: require('assets/icons/alertRefuse.svg').ReactComponent,
  logo: require('assets/icons/Logo.svg').ReactComponent,
  logoText: require('assets/icons/Logo text.svg').ReactComponent,
  unpinMenu: require('assets/icons/circle1.svg').ReactComponent,
  users: require('assets/icons/users.svg').ReactComponent,
  userManagement: require('assets/icons/user-search.svg').ReactComponent,
  provider: require('assets/icons/report-analytics.svg').ReactComponent,
  transaction: require('assets/icons/clipboard-list.svg').ReactComponent,
  purchase: require('assets/icons/cash.svg').ReactComponent,
  phone: require('assets/icons/phone.svg').ReactComponent,
  menu: require('assets/icons/menu-2.svg').ReactComponent,
  send: require('assets/icons/send.svg').ReactComponent,
  playlistsAlbum: require('assets/icons/playlists-album.svg').ReactComponent,
  maskedIcon: require('assets/icons/masked-icon.svg').ReactComponent,
  memberIcon: require('assets/icons/member-icon.svg').ReactComponent,
  vipIcon: require('assets/icons/vip-icon.svg').ReactComponent,
  premiumIcon: require('assets/icons/premium-icon.svg').ReactComponent,
  managerPakages: require('assets/icons/manager-pakages.svg').ReactComponent,
  managerTransaction: require('assets/icons/manager-transaction.svg')
    .ReactComponent,
};

export const MENU_HOLDER: MenuItem[] = [
  {
    key: 'DASHBOARD',
    icon: ICONS.dashBoard,
    permission: [],
  },
  {
    label: 'MANAGERCONTENT',
    permission: [
      USER_PERMISSION.GETS_SONG,
      USER_PERMISSION.GETS_SHORT_VIDEO,
      USER_PERMISSION.GETS_CATEGORY,
      USER_PERMISSION.GETS_ARTIST,
    ],
    children: [
      {
        key: 'SONG',
        icon: ICONS.song,
        permission: [USER_PERMISSION.GETS_SONG],
      },
      {
        key: 'SHORT_VIDEO',
        icon: ICONS.short,
        permission: [USER_PERMISSION.GETS_SHORT_VIDEO],
      },
      {
        key: 'PLAYLISTS_ALBUM',
        icon: ICONS.playlistsAlbum,
        permission: [USER_PERMISSION.GET_ALBUM_PLAYLIST],
      },
      {
        key: 'CATEGORYMANAGER',
        icon: ICONS.category,
        permission: [USER_PERMISSION.GETS_CATEGORY],
      },
      {
        key: 'AUTHOR',
        icon: ICONS.users,
        permission: [USER_PERMISSION.GETS_ARTIST],
      },
    ],
  },
  {
    label: 'SYSTEMADMIN',
    permission: [
      USER_PERMISSION.GETS_USER,
      USER_PERMISSION.GETS_ROLE,
      USER_PERMISSION.GETS_RESOURCE,
    ],
    children: [
      {
        key: 'ADMIN_PARENT',
        icon: ICONS.admin,
        permission: [USER_PERMISSION.GETS_USER, USER_PERMISSION.GETS_ROLE],
        children: [
          {
            key: 'ADMIN',
            permission: [USER_PERMISSION.GETS_USER],
          },
          {
            key: 'ROLE',
            permission: [USER_PERMISSION.GETS_ROLE],
          },
        ],
      },
      {
        key: 'USER_MANAGEMENT',
        permission: [USER_PERMISSION.GETS_USER],
        icon: ICONS.userManagement,
      },
      {
        key: 'CONTENT_PROVIDER',
        permission: [USER_PERMISSION.GETS_RESOURCE],
        icon: ICONS.provider,
      },
    ],
  },
  {
    label: 'MANAGER_SERVICE',
    permission: [
      USER_PERMISSION.GETS_USER,
      USER_PERMISSION.GETS_ROLE,
      USER_PERMISSION.GETS_RESOURCE,
    ],
    children: [
      {
        key: 'MANAGER_PACKAGES',
        icon: ICONS.managerPakages,
        permission: [USER_PERMISSION.GETS_USER],
      },
      {
        key: 'MANAGER_TRANSACTION',
        permission: [USER_PERMISSION.TRANSACTION_MANAGEMENT],
        icon: ICONS.managerTransaction,
      },
    ],
  },
  // {
  //   label: 'TRANSACTION_ALL',
  //   permission: [],
  //   children: [
  //     {
  //       key: 'TRANSACTION',
  //       icon: ICONS.transaction,
  //       permission: [],
  //       children: [
  //         {
  //           key: 'BUY_CREDIT',
  //           permission: [],
  //         },
  //         {
  //           key: 'GIFT',
  //           permission: [],
  //         },
  //       ],
  //     },
  //     {
  //       key: 'IN_APP_PURCHASE',
  //       icon: ICONS.purchase,
  //       permission: [],
  //     },
  //   ],
  // },
];

export const PAGINATION = {
  pageSize: 20,
  pageNumber: 1,
  total: 0,
};

export const TIME_FORMAT = {
  package: 'DD/MM/YYYY',
  filter: 'DD-MM-YYYY',
  table: 'DD-MM-YYYY, h:mm A',
  payload: 'YYYY-MM-DD HH:mm:ss',
  dayjs: 'YYYY-MM-DD',
} as const;

export const MAXLENGTH = {
  PAKAGE: 25,
  PHONE: 10,
  TAX_CODE: 14,
  ROLE_NAME: 30,
  ROLE_DESCRIPTION: 50,
  EMAIL: 50,
  CATEGORY_NAME: 50,
  AUTHOR_NAME: 50,
  TAG_NAME: 30,
  REPRESENTATIVE_NAME: 50,
  COMPANY_NAME: 100,
  RECORD_TITLE: 255,
  AUTHOR_DESCRIPTION: 255,
  CATEGORY_DESCRIPTION: 255,
  REASON: 255,
  ADDRESS: 500,
  NOTE: 2000,
  ALBUM_PLAYLIST_NOTE: 1000,
  RECORD_DESCRIPTION: 5000,
};

export const MAX_TAGS = 20;

export const STATUS_RECORD = {
  DRAFT: 'Lưu nháp',
  DISPLAY: 'Hiển thị',
  REFUSE: 'Từ chối',
  HIDDEN: 'Ẩn',
  PENDING: 'Chờ duyệt',
};

export const COLOR_STATUS_RECORD = {
  DRAFT: 'default',
  DISPLAY: 'green',
  REFUSE: 'red',
  HIDDEN: 'blue',
  PENDING: 'warning',
  ERROR: 'error',
  DEFAULT: 'default',
  FAILED: 'red',
  SUCCESS: 'success',
  RUNNING: 'warning',
};

export const DEFAULT_BACKGROUND_COLOR = '#000000';

export const TYPE_SCREEN = {
  create: 'create',
  edit: 'edit',
  view: 'view',
  unknown: 'unknown',
  draft: 'draft',
  display: 'display',
} as const;

export const MAX_FILE_SIZE = {
  image: 5, // 5MB
  video: 5000 * 1024 * 1024, // 5GB
  lyric: 50 * 1024 * 1024,
  audio: 50 * 1024 * 1024,
} as const;

export const ALLOWED_FORMATS = {
  image: ['image/jpeg', 'image/png'],
  video: ['video/mp4', 'video/quicktime', 'video/mpeg'],
  audio: ['audio/mpeg'],
  lyric: ['srt', 'vtt', 'txt'], // Đảm bảo đây là phần mở rộng file, không phải MIME types
};

export const NOTI_UPLOAD_FILE_FORMAT = {
  video: ['MP4', 'MOV', 'MPEG'],
  audio: ['MP3', 'WAV', 'OGG', 'AAC'],
  lyric: ['SRT', 'VTT'],
  image: ['JPEG', 'PNG', 'JPG'],
} as const;

export const TYPE_FILE = {
  image: 'image',
  video: 'video',
  audio: 'audio',
  lyric: 'lyric',
} as const;

export const DEFAULT_SELECTED_FILES = {
  image: '.JPG,.JPEG,.PNG',
  audio: 'audio/mp3,audio/wav,audio/ogg,audio/aac',
  video: 'video/*',
  lyric: '.srt,.vtt',
} as const;

export const CROP_CONFIG = {
  avatar: 1, // Square crop (1:1)
  thumb: 16 / 9, // Horizontal crop (19:6)
  shortThumb: 9 / 16, // Vertical crop (6:19)
  thumbAlbum: 4 / 3,
};

export const DEFAULT_TABLE_CELL_CHARACTERS_LIMIT = 15;

export const MAX_TOASTS = 3;

export const RECORD_TAB = {
  public: 1,
  private: 2,
};

export const STATUS_RECORD_WORKFLOW = {
  DRAFT: 'DRAFT',
  PENDING: 'PENDING',
  DISPLAY: 'DISPLAY',
  HIDDEN: 'HIDDEN',
  REFUSE: 'REFUSE',
};

export const STATUS_CONTENT_PROVIDER = {
  SENDED: 'SENDED',
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE',
};

export const STATUS_LIST_FILTER = [
  // {
  //   value: STATUS_CONTENT_PROVIDER.SENDED,
  //   label: 'Gửi lời mời',
  // },
  {
    value: STATUS_CONTENT_PROVIDER.ACTIVE,
    label: 'Đang hoạt động',
  },
  {
    value: STATUS_CONTENT_PROVIDER.INACTIVE,
    label: 'Dừng hoạt động',
  },
];

export const LOADER_TIME_OUT = 500;

export const RECORD_TYPES = {
  SONG: 'SONG',
  SHORT_VIDEO: 'SHORT_VIDEO',
  ALBUM: 'ALBUM',
};

export const LOYALTY_LIST = [
  { value: 'BUY_PRODUCT', label: 'BUY_PRODUCT' },
  { value: 'DEPOSIT', label: 'Nạp xu' },
  { value: 'DONATE', label: 'Tặng quà' },
  { value: 'RENEW_PACKAGE', label: 'Gia hạn gói' },
  { value: 'LIKE', label: 'Like' },
  { value: 'COMMENT', label: 'Comment' },
  { value: 'GO_PREMIUM', label: 'Nâng hạng thành viên lên Premium' },
  { value: 'GO_VIP', label: 'Nâng hạng thành viên lên Vip' },
];

export const STATUS_LOYALTY = {
  SUCCESS: 'Thành công',
  FAILED: 'Thất bại',
  RUNNING: 'Đang xử lý',
};

export const DEFAULT_QUERY_FILTER = {
  page: PAGINATION.pageNumber,
  pageSize: PAGINATION.pageSize,
};

export const STATUS_ALBUM_PLAYLISTS = [
  { value: STATUS_RECORD_WORKFLOW.DISPLAY, label: 'Hiển thị' },
  { value: STATUS_RECORD_WORKFLOW.HIDDEN, label: 'Ẩn' },
];

export const CODE_ALBUM_PLAYLISTS = {
  HIGHLIGHT_ALBUM: 'HIGHLIGHT_ALBUM',
  HIGHLIGHT_PLAYLIST: 'HIGHLIGHT_PLAYLIST',
  DAILY_MIX: 'DAILY_MIX',
  PLAYLIST: 'PLAYLIST',
  ALBUM: 'ALBUM',
  NOT_DISPLAYED: 'NOT_DISPLAYED',
};

export const FILE_FORM_FIELD_NAMES = {
  audio: 'audio_file',
  video: 'video_file',
  avatar: 'avatar',
  image_url: 'image_url',
  thumb: 'thumb',
  lyric: 'lyric',
  thumbnail: 'thumbnail',
  thumbnail_square: 'thumbnail_square',
};

export const BYTE_DEFAULT = 1024;

export const FIREBASE_STATUS = {
  success: 'UPDATED',
  failed: 'CALLBACK_UPDATE_FAIL',
  processing: 'PROCESSING',
};
export const FIREBASE_PATH = {
  video: 'song/:id/video',
  audio: 'song/:id/audio',
};

export const TYPE_TRANSACTION = {
  REG: 'REG',
  RENEW: 'RENEW',
  UNREG: 'UNREG',
};

export const TYPE_METHOD = {
  SMS: 'SMS',
  MANUAL: 'MANUAL',
};

export const TYPE_LOADING = {
  create: 'CREATE',
  draft: 'DRAFT',
  publish: 'PUBLISH',
  update: 'UPDATE',
  change_status_record: 'CHANGE_STATUS_RECORD',
  reject_song: 'REJECT_SONG',
} as const;

export const SCROLL_TRIGGER_RATIO = 4 / 5;

export const USER_ACTIONS = {
  MANUAL_RANK_UPGRADE: 'MANUAL_RANK_UPGRADE',
  AUTOMATIC_RANK_UPGRADE: 'AUTOMATIC_RANK_UPGRADE',
  RENEW: 'RENEW',
  DOWNGRADED_SUBCRIPTION_EXPIRATION: 'DOWNGRADED_SUBCRIPTION_EXPIRATION',
  DOWNGRADED_MANUAL: 'DOWNGRADED_MANUAL',
};
